import { Routes } from '@angular/router';
import { HomepageComponent } from './homepage/homepage.component';
import { AboutpageComponent } from './aboutpage/aboutpage.component';
import { CreationspageComponent } from './creationspage/creationspage.component';
import { FaqPageComponent } from './faq-page/faq-page.component';
import { ContactUsPageComponent } from './contact-us-page/contact-us-page.component';
import { HyperiaComponent } from './Pages/Featured/hyperia/hyperia.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { LoginPageComponent } from './admin/login-page/login-page.component';
import { AdminShellComponent, AuthGuard } from '@adminprodigydesign/axis';
import { DashboardHomeComponent } from './admin/dashboard-home/dashboard-home.component';
import { CreationsManagerComponent } from './admin/creations-manager/creations-manager.component';

export const routes: Routes = [
  {
    path: 'home',
    component: HomepageComponent,
  },
  {
    path: 'about',
    component: AboutpageComponent,
  },
  {
    path: 'creations',
    component: CreationspageComponent,
  },
  {
    path: 'faq',
    component: FaqPageComponent,
  },
  {
    path: 'contact-us',
    component: ContactUsPageComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },

  // Admin
  {
    path: 'admin/login',
    component: LoginPageComponent,
  },
  {
    path: 'admin',
    component: AdminShellComponent,
    // canActivate: [AuthGuard],
    data: {
      primarySidebarNavs: [
        { key: 'overview', icon: 'fas fa-house', label: 'Overview' },
        { key: 'content', icon: 'fas fa-folder-open', label: 'Content' },
        { key: 'system', icon: 'fas fa-gear', label: 'System' },
      ],
      sidebarNavs: {
        overview: [{ label: 'Dashboard', route: '/admin/dashboard' }],
        content: [
          { label: 'Creations Manager', route: '/admin/creations-manager' },
          // { label: 'Projects', route: '/admin/projects' },
          // { label: 'Enquiries', route: '/admin/enquiries' },
        ],
        system: [{ label: 'Settings', route: '/admin/settings' }],
      },
    },
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardHomeComponent },
      { path: 'creations-manager', component: CreationsManagerComponent },
      // { path: 'projects', component: AdminProjectsPageComponent },
      // { path: 'enquiries', component: AdminEnquiriesPageComponent },
      // { path: 'settings', component: AdminSettingsPageComponent },
    ],
  },

  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', component: HomepageComponent },
];
